import { authPost } from "../../common/redux/ApiClient";

const baseUrl = process.env.REACT_APP_BASE_URL;

export function callDashboardList(params) {
  return authPost(`${baseUrl}/Agent14.ashx`, params);
}

export function postAgent18(params) {
  return authPost(`${baseUrl}/Agent18.ashx`, params);
}
